import CommingSoonCountDown from "components/commingsoon-count-down";
import PopupLogout from "components/popup-logout";
import { WEB_TEXT_COMMON } from "constants/pageString";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import routes from "routes";
import { urlAssetsCustom } from "utils/common";
const TheHeader = (props) => {
  const [nav, setNav] = useState(false);
  const [active, setActive] = useState(null);
  const navigate = useNavigate();
  const handleNav = () => {
    setNav(true);
    document.body.classList.add("modal-open");
  };
  const handleCloseNav = (e) => {
    setNav(false);
    document.body.classList.remove("modal-open");
  };

  const handleNavigate = (e) => {
    navigate(e);
    handleCloseNav();
  };

  // useEffect(() => {
  //   if (window.location.pathname) {
  //     setActive(
  //       window.location.pathname === "/guide" ? "/" : window.location.pathname
  //     );
  //     document.body.classList.remove("home-page");

  //     if (
  //       window.location.pathname === "/the-le-chuong-trinh" ||
  //       window.location.pathname === "/question"
  //     ) {
  //       document.body.classList.remove("home-page");
  //       document.body.classList.add("bgr-rule");
  //     }

  //     if (window.location.pathname !== "/game") {
  //       localStorage.setItem("dataExchangeCode", JSON.stringify({}));
  //     }
  //   } else {
  //     setActive("/");
  //     document.body.classList.add("home-page");
  //   }
  // }, [window.location.pathname]);

  // const result = routes.filter(
  //   (link) => link.path === "/" || link.path === "/the-le-chuong-trinh"
  // );

  // const commingSoon = JSON.parse(localStorage.getItem("commingSoon"));

  function calculateTimeLeft() {
    let timeLeft = {};
    const difference = JSON.parse(localStorage.getItem("difference"));

    if (difference > 0) {
      localStorage.setItem("commingSoon", "true");
      timeLeft = difference;
    } else {
      localStorage.setItem("commingSoon", "false");
      timeLeft = difference;
    }

    return timeLeft;
  }
  const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());

  React.useEffect(() => {
    const id = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => {
      clearTimeout(id);
    };
  }, [timeLeft]);
  return (
    <>
      <header>
        {props.actionPage && (
          <span
            className="icon-back"
            onClick={() => {
              navigate(props?.isGoback ? -1 : props.actionPage);
            }}
          ></span>
        )}

        {props.namePage ? (
          <p className="d-none">{props.namePage}</p>
        ) : (
          <a
            onClick={() => {
              setActive("/");
              window.scrollTo(0, 0);
            }}
            className="logo"
          >
            <img src={urlAssetsCustom("assets/img/logoBrand.png")} />
          </a>
        )}
        <div className="contact-right">
          {/* <div>Liên hệ</div> */}
          <div
            onClick={() => {
              setActive("/");
              handleNavigate("/");
            }}
          >
            <span className="i-search"></span>
          </div>
        </div>
        <nav id="sidr-main" className={`${nav ? "right" : ""}`}>
          <div className="nav-inner">
            <span className="icon-close d-none" onClick={handleCloseNav}></span>
            <a
              onClick={() => {
                setActive("/");
                handleNavigate("/");
              }}
              className="logo-nav d-none"
            >
              <img src={urlAssetsCustom("assets/img/logoBrand.png")} />
            </a>
            <ul>
              <li className="nav-item">
                {/* <a
                  href="javascript:void(0)"
                  className={`nav-link`}
                  onClick={() => {
                    handleScroll("introduce");
                  }}
                >
                  giới thiệu
                </a> */}
              </li>
              <li className="nav-item">
                {/* <a
                  href="javascript:void(0)"
                  className={`nav-link`}
                  onClick={() => {
                    handleScroll("rule");
                  }}
                >
                  quy định
                </a> */}
              </li>
              <li className="nav-item">
                <img
                  className="logoU"
                  src="assets/img/logoU1.png"
                  alt="logoU"
                />
              </li>
            </ul>
          </div>
        </nav>
        {props.navMenu && (
          <span
            className={`icon-nav ${nav && "active"}`}
            onClick={handleNav}
          ></span>
        )}
        <div className="count-time-header">
          <CommingSoonCountDown />
        </div>
      </header>
      {nav && (
        <PopupLogout
          content={WEB_TEXT_COMMON.LOGOUT}
          handleCloseNav={handleCloseNav}
        />
      )}
    </>
  );
};

export default TheHeader;
